module.exports = __webpack_public_path__ + "img/sec-2-geted-title.3cec4fab.png";